<template>
  <div>
    <h3>Oops, it appears you don't have permissions to view this page</h3>
    <i class="fas fa-frown"></i>
  </div>
</template>

<script>
export default {};
</script>